import React from 'react';
import { ETSY_SHOP_URL } from '../../lib/constants';

const Hero: React.FC = () => (
  <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-20 px-6">
    <div className="max-w-3xl mx-auto text-center">
      <div className="inline-block bg-green-600/20 border border-green-600 text-green-400 px-4 py-1.5 rounded-full text-sm font-medium mb-6">
        🔒 Your private network, anywhere
      </div>
      <h1 className="text-5xl md:text-6xl font-bold mb-5 tracking-tight leading-tight">
        Stop sharing networks with strangers
      </h1>
      <p className="text-xl text-slate-400 mb-10 leading-relaxed">
        Public WiFi is convenient but risky. Megadish creates your own secure, private 
        network — protecting your devices from hackers on hotels, cafés, trains, and planes.
      </p>
      <a
        href={ETSY_SHOP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-9 py-4 rounded-lg font-semibold text-lg transition-colors"
      >
        Shop on Etsy
      </a>
    </div>
  </section>
);

export default Hero;
